<template>
    <div class="row d-flex flex-column pl-3 pb-4" :class="{'opacity-50':isLoading}" v-if="accountDetails">
        <div class="pt-3 pb-4 fs-large">
            <div class="col-12 d-flex flex-column pl-0">
                <div class="fs-larger bold pb-1">{{`${accountDetails.title} `}} <b class="dark fs-largest font-weight-700">{{`(${accountDetails.date})`}}</b>:</div>
                <div class="account-card-sub-title bold">{{`${accountDetails.subTitle}`}}</div>
            </div>
        </div>
        
        <div class="row" v-if="accountDetailsValidation">
            <div class="col-lg-4 col-md-6 col-sm-12 pb-3" v-for="info in accountDetails.info">
                <div class="card d-flex">
                    <div class="d-flex flex-grow-1 flex-column justify-content-between">
                        <div class="fs-large bold">{{`${info.title}:`}}</div>
                        <!-- <div class="account-card-sub-title bold" v-if="info.subTitle">{{`${info.subTitle}`}}</div> -->
                        <span class="bold dark values" v-if="info.valueType === 'number'">{{`${info.value}`}}</span>
                        <span class="bold dark values" v-else-if="info.valueType === 'cash'">{{`${formatPriceWithSpaces(info.value)} €`}}</span>
                    </div>
                    <i class="fs-largest fas fa-info-circle dark pt-1"></i>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-6 pb-3" :class="{'opacity-50':isLoading}"> 
                <div class="d-flex align-items-center card no-info">
                    <div class="d-flex flex-grow-1 flex-row justify-content-between align-items-center">
                        <span class="fs-large bold">No information available!</span>
                        <i class="fs-largest fas fa-exclamation-circle dark"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import { supplierPlanMixin } from '@/mixins/supplierPlan.js'

export default {
    mixins:[
        supplierPlanMixin
    ],
    props: {
        accountDetails: {
            type: Object,
        },
        isLoading: {
            type: Boolean
        },
        type: {
            type: Number
        }
    },
    computed: {
        accountDetailsValidation() {
            if (Object.keys(this.accountDetails).length === 0) {
                return false
            } else {
                return this.accountDetails !== undefined && this.accountDetails.info.length > 0
            }
        }
    }
}
</script>

<style scoped lang="scss">
    @import "~@/assets/scss/_variables.scss";

    .card {
        position: relative;
        min-height: 95px;
        max-width: 375px;
        padding: 20px;
        background: #FFFFFF;
        color: $darkest;
        box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
        border-radius: 5px;

        .textZone {
            padding-right: 5px;
        }

        &.no-info {
            width: 350px;
        }
    }

    .values {
        font-size: 16px;
        margin-top: 15px;
    }

    .account-card-sub-title {
        color: #787878;
        font-size: 12px;
    }
</style>



// WEBPACK FOOTER //
// AccountDetails.vue?2828137e